import { render, staticRenderFns } from "./BreakRules.vue?vue&type=template&id=2778240e&scoped=true"
import script from "./BreakRules.vue?vue&type=script&lang=js"
export * from "./BreakRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778240e",
  null
  
)

export default component.exports